"use client";

import { useEffect, useState } from "react";
import { getBoundaries } from "@/lib/boundaries/boundaryCache";
type BoundaryNode = {
  locationCode: string;
  administrative_level: string;
};
export function useBoundaries(nodes: BoundaryNode[]): Map<string, string> {
  const [geometryByCode, setGeometryByCode] = useState<Map<string, string>>(() => new Map());
  const key = nodes.map(n => `${n.administrative_level}:${n.locationCode}`).sort().join("|");
  useEffect(() => {
    if (nodes.length === 0) {
      setGeometryByCode(new Map());
      return;
    }
    const codesByLevel = new Map<string, string[]>();
    for (const node of nodes) {
      const list = codesByLevel.get(node.administrative_level) ?? [];
      list.push(node.locationCode);
      codesByLevel.set(node.administrative_level, list);
    }
    let active = true;
    Promise.all([...codesByLevel].map(([level, codes]) => getBoundaries(level, codes))).then(maps => {
      if (!active) return;
      const merged = new Map<string, string>();
      for (const map of maps) {
        for (const [code, geometry] of map) merged.set(code, geometry);
      }
      setGeometryByCode(merged);
    });
    return () => {
      active = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
  return geometryByCode;
}